import instance from "./config";

class Axios {
  post(url, body, headers = {}) {
    return instance.post(url, body, headers);
  }
  get(url, params) {
    return instance.get(url, params);
  }
  put(url, body) {
    return instance.put(url, body);
  }
  delete(url) {
    return instance.delete(url);
  }
}

export default new Axios();
